export const LOAD_FUND_GROUPS = 'fund-groups/LOAD_FUND_GROUPS'
export const LOAD_FUND_GROUPS_FOR_MANAGER = 'fund-groups/LOAD_FUND_GROUPS_FOR_MANAGER'
export const UPSERT_FUND_GROUP = 'fund-groups/UPSERT_FUND_GROUP'
export const REMOVE_FUND_GROUP = 'fund-groups/REMOVE_FUND_GROUP'
export const SET_FUND_GROUPS_LOADING = 'fund-groups/SET_FUND_GROUPS_LOADING'
